import { Injectable } from '@angular/core';
import { IMenuItem, menu } from '../../routes/menu';

@Injectable()
export class MenuService {

    private menuItems: IMenuItem[];

    constructor() {
        this.menuItems = [];
    }

    private addMenu(items: IMenuItem[]) {
        this.menuItems = [];
        items.forEach((item) => {
            this.menuItems.push(item);
        });
    }

    getMenu() {

        let fullMenuItems = JSON.parse(JSON.stringify(menu));
        this.addMenu(fullMenuItems);
        
        let menuPolicy = [];

        try {
            menuPolicy = JSON.parse(localStorage.getItem("menu"));
        } catch {
            console.error("Menu policy mancanti")
        }

        if (!menuPolicy || !Object.keys(menuPolicy)?.length) { // Se non ho policy ritorno menu vuoto
            
            return [];
        }

        this.menuItems = this.menuItems.filter(menuItem => {
            return menuPolicy[menuItem.code];
        });

        return this.menuItems;
    }

    get allowedPaths(): string[] {

        return this.getMenu().map(item => item.link);

    }

}
